import { Link } from 'react-router-dom';

const linkGroups = [
  {
    title: '浏览影视',
    links: [
      { to: '/category/movie', label: '电影分类' },
      { to: '/category/tv', label: '电视剧分类' },
      { to: '/special', label: '专题合集' },
      { to: '/news', label: '影视资讯' },
    ],
  },
  {
    title: '关于站点',
    links: [
      { to: '/about', label: '关于我们' },
      { to: '/about', label: '使用说明' },
      { to: '/about', label: '版权声明' },
      { to: '/about', label: '联系方式' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full border-t border-background-200 bg-secondary-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flower-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                樱花<span className="text-primary-600">视频</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              樱花视频是专注影视内容的综合平台，提供最新电影、热播电视剧资源浏览与影视资讯，陪你发现每一部值得一看的好作品。
            </p>
            <p className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-foreground-600">
              <span className="flex items-center gap-1"><i className="ri-mail-line text-primary-500"></i> service@yinghua-video.com</span>
              <span className="flex items-center gap-1"><i className="ri-customer-service-2-line text-primary-500"></i> 周一至周日 9:00-22:00</span>
            </p>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-900">
                <Link to="/about" className="hover:text-primary-600">{group.title}</Link>
              </h4>
              <ul className="mt-4 flex flex-col gap-2">
                {group.links.map((link, idx) => (
                  <li key={`${link.to}-${idx}`}>
                    <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-600">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 樱花视频 yinghua-video.com 保留所有权利。本站内容均为演示数据，仅供学习交流。</p>
          <p className="flex flex-wrap items-center gap-3">
            <Link to="/about" className="hover:text-primary-600">用户协议</Link>
            <Link to="/about" className="hover:text-primary-600">隐私政策</Link>
            <Link to="/about" className="hover:text-primary-600">友情链接</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}